const FeedStructure = {
  rootuser: "", // Unique User ID
  location: "",
  createdOn: "",
  lastActive: "",
  feeds: [
    {
      postId: "", // Unique Post ID
      userId: "",
      useruuid: "",
      userName: "",
      userimage: "",
      descriptions: "",
      timestamp: "", // ISO Date-Time String (e.g., "2025-03-03T12:00:00Z")
      location: "", // Location of the post
      country: "",
      nlikes: 0, // Number of likes
      medias: [
          {
              mediatype: "",
              mediaurl: "",
              nlikes: 0, // Number of likes
              likes: [
                {
                    userId: "",         
                    timestamp: "", // Comment time
                }
            ],
            comments: [
              {
                userId: "", // User who commented
                comment: "", // Comment text
                timestamp: "", // Comment time
                location: "", // Comment location (optional)
              },
            ],
            nshares: 0, // Number of times shared
            shares: [
                {
                    userId: "",
                    platform: "",
                    timestamp: "", // Comment time
                }
            ],
            nsuggests: 0,
            suggests: [
                {
                    suserId: "",
                    tuserid: "",
                    sprofileid: "",
                    tprofileid: "",         
                    timestamp: "", // Comment time
                }
            ],
          }
      ],
      likes: [
          {
              userId: "",         
              timestamp: "", // Comment time
          }
      ],
      comments: [
        {
          userId: "", // User who commented
          comment: "", // Comment text
          timestamp: "", // Comment time
          location: "", // Comment location (optional)
        },
      ],
      nshares: 0, // Number of times shared
      shares: [
          {
              userId: "",
              platform: "",
              timestamp: "", // Comment time
          }
      ],
    },
  ],
};

export default FeedStructure;
